import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedGroupId } from 'ducks/products';
import { usePlannerConfig } from 'contexts/plannerConfig';
import * as R from 'ramda';
import SortingButton from 'components/ProductSidebar/SortingButton/SortingButton';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { reportCloseFilter, reportOpenFilter } from 'analytics/reporters';
import filtersIcon from '@ingka/ssr-icon/paths/filters';
import Pill from 'ui/Pill/Pill';
import Filters from 'components/ProductSidebar/menus/Filters';
import Divider from 'ui/Divider/Divider';
import { useWidget } from 'contexts/widget';

const ButtonRow = styled('div')`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.md};
`;

const ProductSortFilterWidget = () => {
  const {
    plannerConfig: { productGroups }
  } = usePlannerConfig();
  const { config } = useWidget();
  const { formatMessage } = useIntl();
  const selectedGroupId = useSelector(getSelectedGroupId);
  const [isFilterVisible, setFiltersVisibile] = useState<boolean>(false);
  const [shouldAnimate, setShouldAnimate] = useState<boolean>(false);

  const selectedGroup = R.find(R.propEq('id', selectedGroupId), productGroups);

  const groupHasFilters = !!selectedGroup?.mainMenu.filters?.length;
  const groupHasSorting = config?.sorting?.length;

  if (!groupHasFilters && !groupHasSorting) return <></>;

  const triggerAnalyticsEvent = (filterVisible: boolean) => {
    if (filterVisible) {
      reportOpenFilter({ menu: selectedGroupId });
    } else {
      reportCloseFilter({ menu: selectedGroupId });
    }
  };

  const toggleFilters = () => {
    setShouldAnimate(true);
    setFiltersVisibile(prev => !prev);
    triggerAnalyticsEvent(!isFilterVisible);
  };

  return (
    <>
      <ButtonRow>
        {groupHasSorting && <SortingButton />}
        {groupHasFilters && (
          <Pill
            label={formatMessage({ id: 'storageone.filterButtonNewMenu' })}
            ssrIcon={filtersIcon}
            onClick={toggleFilters}
            aria-expanded={isFilterVisible}
            selected={isFilterVisible}
            data-testid="filter-button"
          />
        )}
      </ButtonRow>

      {groupHasFilters && (
        <Filters shouldAnimate={shouldAnimate} isFilterVisible={isFilterVisible} />
      )}
      {isFilterVisible && <Divider />}
    </>
  );
};

export default ProductSortFilterWidget;
